//============================================================
// appsolut Theme VIENNA - v1.0.0
//============================================================
//
// Based on Otis Kit PRO - v2.0.1 from www.creative-tim.com
//
//============================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby-theme-material-ui';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import YouTubeIcon from '@mui/icons-material/YouTube';

// Otis Kit PRO components
import StyledBox from '../../../controls/StyledBox';
import StyledTypography from '../../../controls/StyledTypography';

function SocialIcon({ socialType }) {
  if (socialType === 'facebook') return <FacebookIcon fontSize="medium" />;
  if (socialType === 'twitter') return <TwitterIcon fontSize="medium" />;
  if (socialType === 'instagram') return <InstagramIcon fontSize="medium" />;
  if (socialType === 'pinterest') return <PinterestIcon fontSize="medium" />;
  if (socialType === 'linkedin') return <LinkedInIcon fontSize="medium" />;
  if (socialType === 'github') return <GitHubIcon fontSize="medium" />;
  if (socialType === 'youtube') return <YouTubeIcon fontSize="medium" />;
  return null;
}

function CenteredFooter({ company, links, socials, light }) {
  const logoImage = company && company.logo ? company.logo : {};

  const renderLinks = links.map((link, key) => {
    const elementKey = `${link.name}-${key}`;

    return (
      <StyledTypography
        key={elementKey}
        component={Link}
        to={link.link}
        variant="body2"
        color={light ? 'white' : 'secondary'}
        fontWeight="regular"
      >
        {link.name}
      </StyledTypography>
    );
  });

  const renderSocials = socials.map((social, key) => {
    const elementKey = `${social.link}-${key}`;

    return (
      <StyledTypography
        key={elementKey}
        component={Link}
        to={social.link}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
        color={light ? 'white' : 'secondary'}
        fontWeight="regular"
      >
        <SocialIcon socialType={social.profileType} />
      </StyledTypography>
    );
  });

  return (
    <StyledBox component="footer" py={6}>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={8}>
          <Stack display="flex" direction="row" justifyContent="center" spacing={3} mt={1} mb={3}>
            <StyledBox mb={2}>
              <img src={logoImage.src} alt={logoImage.alt} />
            </StyledBox>
          </Stack>
        </Grid>
        <Grid item xs={10} lg={8}>
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="center"
            spacing={{ xs: 2, lg: 3, xl: 6 }}
            mb={3}
          >
            {renderLinks}
          </Stack>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Stack display="flex" direction="row" justifyContent="center" spacing={3} mt={1} mb={3}>
            {renderSocials}
          </Stack>
        </Grid>
        <Grid item xs={12} lg={8} sx={{ textAlign: 'center' }}>
          <StyledTypography variant="body2" color={light ? 'white' : 'secondary'}>
            {company.copyright}
          </StyledTypography>
        </Grid>
      </Grid>
    </StyledBox>
  );
}

// Setting default values for the props of CenteredFooter
CenteredFooter.defaultProps = {
  light: false,
};

// Typechecking props for the CenteredFooter
CenteredFooter.propTypes = {
  company: PropTypes.instanceOf(Object),
  links: PropTypes.instanceOf(Array),
  socials: PropTypes.instanceOf(Array),
  light: PropTypes.bool,
};

export default CenteredFooter;
